<template>
	<div class="box">
	  <div class="content-front">
		<div class="cf-inner">
		  <div class="inner">
			  <img class="front-img"
  			  :src="require(`@/assets/images/benefits/${benefit.imgSrc}`)"
  			  alt=""
  			/>

		  </div>

		</div>

	  </div>
	  <div class="content-back">
		<!-- <div class="cf-inner"> -->
		  <!-- <div class="inner"> -->
		   <div class="benefit-content">
			   <!-- <div class="content-body"> -->
				<p v-html="benefit.text"></p>
   	   			<!-- <p>
   	   			  {{ benefit.text }}
   	   		    </p> -->
			   <!-- </div> -->
		   </div>
		  <!-- </div> -->

		<!-- </div> -->

	  </div>
	  <div class="benefit_header">
	  	 <h2 class="">{{ benefit.header }}</h2>
	  </div>

	</div>
</template>


<script>
import { reactive, toRefs, computed } from "vue";
import { useStore } from "vuex";
export default {
  name: "flipBox",
  props: ["benefit"],
  setup() {
    const store = useStore();

    // State
    const state = reactive({
	  iconSrc: computed(() =>
		 "icon-ATL.svg"
	  ),
    });


    return { ...toRefs(state) };
  },
}
</script>
<style lang="scss" scoped>
.box {
  height: 175px;
  width:auto;

  @include media-breakpoint-down(sm) {
    width:160px;
	height: auto;
  }
  @include media-breakpoint-only(md) {
	  width:160px;
  	height: auto;
  }
  @media only screen and (min-width: 1023px) and (max-width: 1025px) and (-webkit-min-device-pixel-ratio: 1.5) {
	  width: 175px;
      height:auto;
  }
	cursor:pointer;
  flex: 1;
  margin: 10px 5px;
  position: relative;
  transform-style: preserve-3d;
  perspective: 1000px;
  backface-visibility: hidden;
  transition: 0.9s ease;

  @include media-breakpoint-down(lg) {
    flex: 0 0 calc(50% - 5px);
  }
  @include media-breakpoint-down(sm) {
    flex: 0 0 100%;
	transform-style: unset;
	// margin-bottom:10px;
  }
  @include media-breakpoint-only(md) {
	    flex: 0 0 100%;
  }
  .benefit_header{
	  width: 92%;
	  margin: 0 auto;
	  h2{

	    display: flex;
	    flex-direction: column;
	    justify-content: center;
	    align-items: center;
		padding: 10px 5px;
		background: #0B2255;
		font-family: 'Verlag Light';
		font-style: normal;
		font-weight: 325;
		font-size: 12px;
		line-height: 145%;
		text-align: center;
		text-transform: uppercase;
		color: #FFFFFF;
		@include media-breakpoint-down(sm) {
			font-size: 9px;
			padding: 5px 5px;
		}
		@include media-breakpoint-only(md) {
			font-size: 11px;
  		   padding: 5px 5px;
	    }
	  }
  }
  .content-front{
    position: relative;

    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
	// &:last-child(){
		// background: #0B2255;
	// }

	@include media-breakpoint-down(sm) {
		height: auto;
	}
	@include media-breakpoint-only(md) {
		height: auto;
	}

	.front-img{
		height: 180px;
		width:100%;

		// object-fit:contain;
		@include media-breakpoint-down(sm) {
			width: 100%;
			height: 100%;
			// margin: 0px 5px;

		}
		@include media-breakpoint-only(md) {
			width: 100%;
			height: 100%;
		}
	}
  }

  .content-back {
	    position: absolute;
	    left: 0;
	    top: 50%;
		padding: 0px 10px;
		@include media-breakpoint-down(sm) {
			width: 100%;
			height: 112px;
			// width: 175px;
			// height: 175px;
			padding: 0px 5px;
			left:0px;
			top: 0%;
			transform: translate(00%, 0%);
		}
		@media only screen and (min-width: 1023px) and (max-width: 1025px) and (-webkit-min-device-pixel-ratio: 1.5) {
	        height: 180px;
			width: 100%;
			padding: 0px 5px;
			left:0px;
			top: 0%;
			transform: translate(00%, 0%);
	    }
		@include media-breakpoint-only(md) {
			width: 100%;
			height: 112px;
			// width: 175px;
			// height: 175px;
			padding: 0px 5px;
			left:0px;
			top: 0%;
			transform: translate(00%, 0%);
		}
		background: rgba(0, 0, 0, 0.75);
	    height: 180px;
		width:100%;
	    z-index: 0;
		opacity:0;
		transform: translate(00%, -50%);
	    color: white;
		font-family: 'Verlag Light';
		text-align:center;
		.benefit-content{
			padding:10px;
			height:100%;
			display:flex;
			justify-content: center;
			align-items:center;
			p{
				font-size: 15px;
				font-family: 'Verlag Light';
				display:block;
				margin: auto 0;
				@include media-breakpoint-down(sm) {
					font-size: 9px;
				}
				@include media-breakpoint-only(md) {
						font-size: 9px;
				}
				@media only screen and (min-width: 1023px) and (max-width: 1025px) and (-webkit-min-device-pixel-ratio: 1.5) {
					font-size: 14px;
				}

			}

		}

  }
  &:hover {
    .content-front {
		// background: rgba(0, 0, 0, 0.75);
    }
    .content-back {
		transition: all 0.3s ease 0s;
		opacity:1;
    }
  }
}
</style>
